export default "__VITE_ASSET__ebab35fd__"